import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { products } from '../Data/products'; 

const ProductsPage = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [Products, setProducts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();
  useEffect(() => {
    const fetchProducts = async () => {
      try {
        await new Promise(resolve => setTimeout(resolve, 1000));   
        setProducts(products);
        setIsLoading(false);
      } catch (error) {
        console.error("Error fetching products:", error);
        setIsLoading(false);
      }
    };

    fetchProducts();
  }, []);

  const filteredProducts = Products.filter(product =>
    product.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleProductClick = (productId) => {
    navigate(`/products/${productId}`); 
  };

  return (
    <div className="products-page-container">
      <section className="products-section">
        <h1 className="section-titlem">Our Products</h1>
        <div className="search-container">
          <input
            type="text"
            placeholder="Search products..."
            className="search-bar"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>

        {isLoading ? (
          <div className="loading">Loading products...</div>
        ) : (
          <div className="products-gridm">
            {filteredProducts.map((product) => (
              <div 
                key={product.id} 
                className="product-cardm"
                onClick={() => handleProductClick(product.id)} 
              >
                <img src={product.image} alt={product.name} className="product-image" />
                <div className="product-info">
                  <h2>{product.name}</h2>
                  {/* <p>{product.description}</p> */}
                  <p className="product-category">{product.category}</p>
                </div>
                <button className="read-more-btn">View Details</button>
              </div>
            ))}
          </div>
        )}
      </section>
    </div>
  );
}

export default ProductsPage;